import experiment from 'experiment';
import { getResizeGapsUserPreferences } from '../resizeGapsUserPreferences';
import { interactions, pinModeSelectors } from '#packages/stateManagement';

import type { ResizeGapsScope } from '../resizeGapsScope';

export const isEnabled = (scope: ResizeGapsScope): boolean => {
  const { editorAPI, resizeGapsStore } = scope;
  const editorState = editorAPI.store.getState();

  const isDraggingAnotherComp =
    editorState.mouseActions.dragInProgress && !resizeGapsStore.getIsResizing();
  const isEnabledInToolsMenu = getResizeGapsUserPreferences(scope);
  const isMobileEditor = editorAPI.isMobileEditor();
  const isExperimentOpen = experiment.isOpen('se_resizeGaps');

  const isInteractionMode =
    interactions.selectors.isInInteractionMode(editorState);
  const isPinMode = pinModeSelectors.isOpen(editorState);
  const isZoomMode = editorAPI.zoomMode.isInZoomMode();

  return (
    isExperimentOpen &&
    isMobileEditor &&
    isEnabledInToolsMenu &&
    !isDraggingAnotherComp &&
    !isInteractionMode &&
    !isPinMode &&
    !isZoomMode
  );
};
